import React from 'react';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
  label?: string;
  hint?: React.ReactNode;
  hintClassName?: string;
  hintId?: string;
  hintHidden?: boolean;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className = '', label, hint, hintClassName, hintId, hintHidden, id, ...props }, ref) => {
    return (
      <>
        {label ? <label htmlFor={id}>{label}</label> : null}
        <textarea ref={ref} className={className || undefined} {...props} />
        {hint ? (
          <small
            id={hintId}
            hidden={hintHidden}
            className={`hint${hintClassName ? ' ' + hintClassName : ''}`}
          >
            {hint}
          </small>
        ) : null}
      </>
    );
  }
);

Textarea.displayName = 'Textarea';

export default Textarea;
